import axios from "axios";

const API_URL = `${window['getConfig'].REACT_APP_URL}`;

const getEmployeeDropdown = () => {
  const token = localStorage.getItem("_ux98c_v1");

  return axios.get(`${API_URL}/employee/empDropdownSub`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

const getb2bEmployeeDashboard = ({ id, from, to }) => {
  const token = localStorage.getItem("_ux98c_v1");

  return axios.get(`${API_URL}/employee/employeeDashboardB2B`, {
    params: {
      id,
      from,
      to,
    },
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

const getB2BTodaysFollowUps = () => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(`${API_URL}/lead/getb2bTodaysFollowUps`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });
};


const getb2cEmployeeDashboard = ({ id, from, to }) => {
  const token = localStorage.getItem("_ux98c_v1");

  return axios.get(`${API_URL}/employee/employeeDashboardB2C`, {
    params: {
      id,
      from,
      to,
    },
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

const getB2CTodaysFollowUps = () => {
    const token = localStorage.getItem("_ux98c_v1");

    return axios.get(`${API_URL}/lead/getb2cTodaysFollowUps`, {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });
};



export{
getEmployeeDropdown,
getb2bEmployeeDashboard,
getB2BTodaysFollowUps,
getb2cEmployeeDashboard,
 getB2CTodaysFollowUps,
}